import { Market } from './market';

export class Region {
  id: number = null;
  name: string = null;
  markets?: Array<Market> = [];
  selected?: boolean;
  acronym: string;
}
